<div class="banner">
  <div class="mask"></div>
  <div class="slogin">愛心認養，幸福延續</div>
</div>
